import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileSpreadsheet = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M13 3.50006V7.00006C13 8.10463 13.8954 9.00006 15 9.00006H18.5M8.5 17.5001V16.0001M12 17.5001V13.0001M15.5 17.5001V15.0001M7 3.00006H12.1716C12.702 3.00006 13.2107 3.21077 13.5858 3.58585L18.4142 8.41427C18.7893 8.78935 19 9.29806 19 9.82849V19.0001C19 20.1046 18.1046 21.0001 17 21.0001H7C5.89543 21.0001 5 20.1046 5 19.0001V5.00006C5 3.89549 5.89543 3.00006 7 3.00006Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.75 2.00006H12V7.25006C12 8.76884 13.2312 10.0001 14.75 10.0001H20V19.2501C20 20.7688 18.7688 22.0001 17.25 22.0001H6.75C5.23122 22.0001 4 20.7688 4 19.2501V4.75006C4 3.23128 5.23122 2.00006 6.75 2.00006ZM9.25 16.7501C9.25 16.3358 8.91421 16.0001 8.5 16.0001C8.08579 16.0001 7.75 16.3358 7.75 16.7501V18.2501C7.75 18.6643 8.08579 19.0001 8.5 19.0001C8.91421 19.0001 9.25 18.6643 9.25 18.2501V16.7501ZM12 13.0001C12.4142 13.0001 12.75 13.3358 12.75 13.7501V18.2501C12.75 18.6643 12.4142 19.0001 12 19.0001C11.5858 19.0001 11.25 18.6643 11.25 18.2501V13.7501C11.25 13.3358 11.5858 13.0001 12 13.0001ZM16.25 15.7501C16.25 15.3358 15.9142 15.0001 15.5 15.0001C15.0858 15.0001 14.75 15.3358 14.75 15.7501V18.2501C14.75 18.6643 15.0858 19.0001 15.5 19.0001C15.9142 19.0001 16.25 18.6643 16.25 18.2501V15.7501Z'
          fill='currentColor'
        />
        <path
          d='M19.4874 8.42684C19.5112 8.45064 19.5343 8.47506 19.5566 8.50006H14.75C14.0596 8.50006 13.5 7.94042 13.5 7.25006V2.44349C13.525 2.46577 13.5494 2.48882 13.5732 2.51262L19.4874 8.42684Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
